module.exports = __webpack_public_path__ + "img/ORDER-ALL.ef6f1312.png";